import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'moment/locale/de';
import enhanceWithClickOutside from 'react-click-outside';
import Icon from '../Icon';
var AppConfig = require('../../../config.json');

/**
 * InputOrderFormDate for any form.
 */

const id = uniqueId('input_'); 
const dateFormat = AppConfig.dateFormat; 

class InputOrderFormDate extends React.Component {
	constructor(props) {
	    super(props);
	    this.onFocus = this.onFocus.bind(this);
	    this.onBlur = this.onBlur.bind(this);
	    this.toggleCalendar = this.toggleCalendar.bind(this);
	    this.handleCalendarChange = this.handleCalendarChange.bind(this);
	    this.doVerify = this.doVerify.bind(this);
	    this.state = {isFocused: false, isFilled: false, hasError: false, errorMsg:'', isOpen: false, date:Datetime.moment()};
	}
	componentDidMount() {
		if(this.props.value!=='') {
			this.fieldInput.value = this.props.value;
			this.setState({date: moment(this.props.value, dateFormat)});
		}
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
	}
	onFocus(e) {
		this.setState({isFocused: true});
	}
	onBlur(e) {
		this.setState({isFocused: false});
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
		this.doVerify();
	}
	handleClickOutside() {
		if(this.state.isOpen) {
		   this.toggleCalendar();
		}
	 }
	doVerify() {
		var hasError = false, errorMsg = '';
		if(this.props.required && this.fieldInput.value==='') {
			hasError = true;
			errorMsg = 'Dieses Feld wird benötigt.';
		} else if(this.fieldInput.value!=='') {
			var t = moment(this.fieldInput.value, dateFormat);
			if(!t.isValid()) {
				hasError = true;
				errorMsg = 'Bitte geben Sie ein gültiges Datum an (TT.MM.JJJJ).';
			}
		}
		this.setState({hasError: hasError, errorMsg: errorMsg});
		if(!hasError) {
			this.fieldInput.value = moment(this.fieldInput.value, dateFormat).format(dateFormat);
			this.setState({date: moment(this.fieldInput.value, dateFormat)});
		}
		this.props.onChange(this.fieldInput, hasError, this.props.itemkey);
	}
	handleCalendarChange(e) {
		this.fieldInput.value = e.format(dateFormat);
		this.setState({hasError: false, errorMsg: '', isFilled: true, date:e});
	   	this.toggleCalendar();
	   	this.doVerify();
	}
	toggleCalendar() {
		var newState = !this.state.isOpen;
		this.setState({isOpen: newState});
	}
    render () {
    	
		const classNames = (this.state.isFocused?"focused ":"")+(this.state.isFilled?"filled ":"")+(this.state.hasError?"error ":"")+"inputfield dateselect";
		
		return (
			<div className={classNames}>
				<input autoCapitalize="off" autoCorrect="off" id={id} type="text" name={this.props.name} onFocus={this.onFocus} onBlur={this.onBlur} ref={(input) => { this.fieldInput = input; }}  />
				<label htmlFor={id}>{this.props.label}{this.props.required?"*":""}</label>
				<Icon filename="calendar" onClick={() => this.toggleCalendar()} />
				{this.state.hasError && this.state.errorMsg!==''?<div className="errormsg">{this.state.errorMsg}</div>:null}
				{this.state.isOpen?
					<div className="calendar">
					<Datetime
					value={this.state.date}
					input={false}
					locale="de"
					onChange={this.handleCalendarChange}
					dateFormat={dateFormat}
					timeFormat={false} /></div>
					:null
				}
			</div>
		)
    }

}
InputOrderFormDate.propTypes = {
	/** InputOrderFormDate verify */
	verify: PropTypes.string,
	/** InputOrderFormDate required */
	required: PropTypes.bool,
	/** InputOrderFormDate value */
	value: PropTypes.string,
	/** InputOrderFormDate value */
	itemkey: PropTypes.string,
	/** InputOrderFormDate Label */
	label: PropTypes.string.isRequired,
}


InputOrderFormDate.defaultProps = {
  value: "",
  itemkey: "",
  required: false
}

export default enhanceWithClickOutside(InputOrderFormDate);


// WEBPACK FOOTER //
// ./src/components/atoms/InputOrderFormElements/InputOrderFormDate.js